// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.surveycycles_container_surveycycles__\\+ZHFN {
    display: flex;
    flex: 5 1;
    flex-direction: column;
    align-items: flex-start;
    align-content: baseline;
    justify-content: center;
    background-color: var(--hsrcBackgroundLight);
    border-radius: 1rem;
    padding: 2rem;
}

.surveycycles_featuredItem__XHxJj {
    flex: 1 1;
        margin: 0px 20px;
        padding: 30px;
        border-radius: 10px;
        cursor: default;
}

.surveycycles_featuredTitleHeader__umAna {
    color: var(--hsrcDarkBlue);
    font-size: 15px;
    font-weight: bold;
}

.surveycycles_featuredText__6w0rT {
    color: var(--hsrcDarkBlue);
    font-size: 14px;
    font-weight: normal;
}

.surveycycles_flex_row_container__wNwdc {
    display: inline-flexbox;
    flex-direction: row;
    flex: 11 1;
    width: 100%;
    align-items: flex-start;
    align-content: center;
    justify-content: left;
}

.surveycycles_pageTitleIcon__K0Sqc {
    height:auto;
}

.surveycycles_table_header_cell__K6Eji {
    background-color: var(--hsrcMidGreen);
}

.surveycycles_tooltip__16eoy {
    background-color: #0078D4;
    color: white;
    font-size: 12px;
    padding: 10px;
    border-radius: 5px;
    max-width: 100%;
}

.surveycycles_tooltip__16eoy .MuiTooltip-arrow {
    color: #0078D4;
}

.surveycycles_checkbox__NgW9k {
    padding: 4px;
}

.surveycycles_checkbox__NgW9k .MuiSvgIcon-root {
    width: 20px;
    height: 20px;
}`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/pages/SystemAdministration/SurveyCycles/surveycycles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAO;IACP,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,4CAA4C;IAC5C,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,SAAO;QACH,gBAAgB;QAChB,aAAa;QACb,mBAAmB;QACnB,eAAe;AACvB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,UAAQ;IACR,WAAW;IACX,uBAAuB;IACvB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".container_surveycycles {\r\n    display: flex;\r\n    flex: 5;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    align-content: baseline;\r\n    justify-content: center;\r\n    background-color: var(--hsrcBackgroundLight);\r\n    border-radius: 1rem;\r\n    padding: 2rem;\r\n}\r\n\r\n.featuredItem {\r\n    flex: 1;\r\n        margin: 0px 20px;\r\n        padding: 30px;\r\n        border-radius: 10px;\r\n        cursor: default;\r\n}\r\n\r\n.featuredTitleHeader {\r\n    color: var(--hsrcDarkBlue);\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n}\r\n\r\n.featuredText {\r\n    color: var(--hsrcDarkBlue);\r\n    font-size: 14px;\r\n    font-weight: normal;\r\n}\r\n\r\n.flex_row_container {\r\n    display: inline-flexbox;\r\n    flex-direction: row;\r\n    flex: 11;\r\n    width: 100%;\r\n    align-items: flex-start;\r\n    align-content: center;\r\n    justify-content: left;\r\n}\r\n\r\n.pageTitleIcon {\r\n    height:auto;\r\n}\r\n\r\n.table_header_cell {\r\n    background-color: var(--hsrcMidGreen);\r\n}\r\n\r\n.tooltip {\r\n    background-color: #0078D4;\r\n    color: white;\r\n    font-size: 12px;\r\n    padding: 10px;\r\n    border-radius: 5px;\r\n    max-width: 100%;\r\n}\r\n\r\n.tooltip :global(.MuiTooltip-arrow) {\r\n    color: #0078D4;\r\n}\r\n\r\n.checkbox {\r\n    padding: 4px;\r\n}\r\n\r\n.checkbox :global(.MuiSvgIcon-root) {\r\n    width: 20px;\r\n    height: 20px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_surveycycles": `surveycycles_container_surveycycles__+ZHFN`,
	"featuredItem": `surveycycles_featuredItem__XHxJj`,
	"featuredTitleHeader": `surveycycles_featuredTitleHeader__umAna`,
	"featuredText": `surveycycles_featuredText__6w0rT`,
	"flex_row_container": `surveycycles_flex_row_container__wNwdc`,
	"pageTitleIcon": `surveycycles_pageTitleIcon__K0Sqc`,
	"table_header_cell": `surveycycles_table_header_cell__K6Eji`,
	"tooltip": `surveycycles_tooltip__16eoy`,
	"checkbox": `surveycycles_checkbox__NgW9k`
};
export default ___CSS_LOADER_EXPORT___;
